import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import Newsletter from "@/pages/Newsletter";

export const Route = createFileRoute("/es/suscribete")({
  head: () => buildRouteHead("/es/suscribete"),
  component: Newsletter,
});

